import { MultiTranslateHttpLoader } from '../core/services/system/multi.translations.http.loader.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';

/**
 * Corporate with @ngx-translate multiple languages support library.
 * Load multiple languages files from "./assets/i18n/*.json".
 *
 * Note: For performance, each module only load json files under the folder with name of module name.
 */
export function SJITranslateLoader(http: HttpClient) {
     // return new TranslateHttpLoader(http, './assets/i18n/demo/', '.json');
    return new MultiTranslateHttpLoader(http, [
        {prefix: './assets/i18n/core/', suffix: '.json'}
      ]);
}
